import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { ICustomPropertiesPanelButtonProps } from './types';
import { CLASS_CARD_DETAILS_SECTION, SECTION_CREATION_WAITING_TIME } from '../../../constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { CustomPropertiesSectionHOC } from '../../hocs/CustomPropertiesSectionHOC/CustomPropertiesSectionHOC';
import { getAsidePanelActionsButtonTooltip } from '../../../../asidePanel/helpers/getAsidePanelActionsButtonTooltip';
import {
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER,
    CLASS_ASIDE_PANEL_ACTIONS_POPUP
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { CLASS_ASIDE_PANEL_BODY } from '../../../../asidePanel/components/AsidePanelBody/constants';
import { v4 as uuidv4 } from 'uuid';
import { ITooltipInheritedProps } from 'kui';
import { CLASS_DATEPICKER } from '../../../../../base/components/Datepicker/components/constants';
import { CARD_SECTION_CUSTOM } from '../CustomPropertiesSection/constants';
import { CLASS_CUSTOM_PROPERTY_ITEM } from '../../../../../base/components/CustomProperties/components/constants';

export function CustomPropertiesPanelButton ({
    elements,
    indicator,
    isEmpty,
    isEssentialFeature,
    isProFeature,
    isShowTooltip,
    isDisallow,
    isShow,
    onClick
}: ICustomPropertiesPanelButtonProps) {
    if (!isShow) return null;

    const classNameSection = CLASS_CARD_DETAILS_SECTION + '--custom';

    const { setIsScrollDisabled, showedProperties, openedProperty, addShowedProperty, isCommentsColumn } = React.useContext(AsidePanelContext);
    const isShowed = showedProperties.has(EAsidePanelProperty.CARD_CUSTOM) && openedProperty !== EAsidePanelProperty.CARD_CUSTOM;
    const [isOpened, setIsOpened] = React.useState(null);
    const [key, setKey] = React.useState(uuidv4());
    const timer = React.useRef(null);

    const onOpened = () => {
        setIsOpened(true);
        timer.current = setTimeout(checkScroll, 1000);
    }
    const onClosed = () => setIsOpened(false);

    /**
     * Попапы обычно вписаны в экран и скрол панели отключается, чтобы ничего не скакало при добавлении-удалении свойств.
     * Но у CustomProperties нестандартный попап, в нём должны поместиться все 100500 кастомных полей доски.
     * Если попап не помещается, включить обратно скрол панели.
     */
    function checkScroll () {
        const body = document.querySelector(`.${CLASS_ASIDE_PANEL_BODY}`) as HTMLElement;
        const dropdown = document.querySelector(`.${CLASS_ASIDE_PANEL_ACTIONS_POPUP}--custom > .kui-dropdown__item`) as HTMLElement;
        if (!body || !dropdown) return;
        setIsScrollDisabled(dropdown.offsetHeight < body.offsetHeight);
    }

    React.useEffect(() => {
        timer.current = setTimeout(checkScroll, 100);
    }, [elements]);

    React.useEffect(() => {
        return () => {
            if (timer.current) clearTimeout(timer.current);
        }
    }, []);

    const onToggleEdit = (value: boolean) => {
        timer.current = setTimeout(() => {
            if (value) {
                setIsScrollDisabled(false);
            } else {
                checkScroll();
                setKey(uuidv4());
            }
        }, 100);
    }

    const tooltip: ITooltipInheritedProps = isShowTooltip ? getAsidePanelActionsButtonTooltip({ value: CARD_SECTION_CUSTOM }) : null;

    return (
        <AsidePanelActionsButton
            className={CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER + '--custom'}
            dropdownClassName={`${CLASS_ASIDE_PANEL_ACTIONS_POPUP}--custom`}
            indicatorNumber={indicator}
            icon={'plus'}
            isDisabled={isDisallow}
            isIconHiddenOnFullSize={true}
            isOpened={isOpened}
            openedProperty={EAsidePanelProperty.CARD_CUSTOM}
            sectionSelector={`.${classNameSection}`}
            title={CARD_SECTION_CUSTOM}
            tooltip={tooltip}
            onClick={() => {
                onClick();
                if (!isShowed) {
                    addShowedProperty(EAsidePanelProperty.CARD_CUSTOM, isCommentsColumn);
                    if (!isEmpty) return;
                    setTimeout(() => {
                        const button = document.querySelector(`.${classNameSection} .settings-section__title-add`) as HTMLButtonElement;
                        if (button) {
                            button.focus();
                            button.click();
                        }
                    }, SECTION_CREATION_WAITING_TIME);
                }
            }}
            onOpen={onOpened}
            isEssentialFeature={isEssentialFeature}
            isProFeature={isProFeature}
            dropdownKey={key}
            notBlurClasses={[
                'kui-snackbar--variant_promt',
                `card-details-custom__form-type-dropdown`,
                CLASS_DATEPICKER + '__date-dropdown',
                CLASS_CUSTOM_PROPERTY_ITEM + '-type-select-dropdown',
            ]}
        >
        </AsidePanelActionsButton>
    );
}
